import Vue from 'vue'
import Vuex from 'vuex'
import messages from './modules/messages'
import lists from './modules/lists'
import users from './modules/users'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isTouch: false
    },
    actions: {
        setTouchDevice ({ commit }, isTouch) {
            commit('setTouchDevice', isTouch)
        }
    },
    mutations: {
        setTouchDevice (state, isTouch) {
            state.isTouch = isTouch
        },
    },
    modules: {
        messages,
        lists,
        users
    }
})